<template>
  <div class="widget-card" :class="{ 'is-expanded': isExpanded }">
    <div class="widget-header" draggable="true" @dragstart="onDragStart" @dragend="onDragEnd">
      <div class="widget-title" @click="toggleExpand">
        <app-icon  class="app-icon drag-handle" name="drag_indicator"></app-icon>
        <app-icon  class="app-icon" :name="config.icon"></app-icon>
        <span>{{ config.title || config.name }}</span>
      </div>
      <div class="widget-actions">
        <el-dropdown trigger="click" @command="setWidth" size="mini">
          <button class="btn-action" title="设置宽度">
            <app-icon  class="app-icon" name="aspect_ratio"></app-icon>
          </button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="25">25%</el-dropdown-item>
            <el-dropdown-item :command="33">33%</el-dropdown-item>
            <el-dropdown-item :command="50">50%</el-dropdown-item>
            <el-dropdown-item :command="66">66%</el-dropdown-item>
            <el-dropdown-item :command="75">75%</el-dropdown-item>
            <el-dropdown-item :command="100">100%</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <button class="btn-action" @click="toggleExpand">
          <app-icon  class="app-icon" :name="isExpanded ? 'unfold_less' : 'unfold_more'"></app-icon>
        </button>
        <button class="btn-action btn-remove" @click="$emit('remove')">
          <app-icon  class="app-icon" name="close"></app-icon>
        </button>
      </div>
    </div>
    <div class="widget-body" v-show="isExpanded">
      <component :is="config.component" v-bind="config.props" @update="onUpdate"></component>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetCard',
  props: {
    config: { type: Object, required: true }
  },
  data() {
    return { isExpanded: true }
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    },
    setWidth(width) {
      this.$emit('resize', { id: this.config.id, width: String(width) })
    },
    onDragStart(e) {
      e.stopPropagation()
      e.dataTransfer.setData('text/plain', String(this.config.id))
      e.dataTransfer.effectAllowed = 'move'
      this.$el.classList.add('is-dragging')
    },
    onDragEnd() {
      this.$el.classList.remove('is-dragging')
    },
    onUpdate(data) {
      this.$emit('update', { id: this.config.id, data })
    }
  }
}
</script>

<style scoped>
.widget-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s;
}

.widget-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.widget-card.is-dragging {
  opacity: 0.4;
}

.widget-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: #f5f7fa;
  border-bottom: 1px solid #e5e7eb;
  cursor: grab;
  user-select: none;
}

.widget-header:active {
  cursor: grabbing;
}

.widget-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
}

.widget-title .app-icon {
  font-size: 18px;
  color: #1a73e8;
}

.drag-handle {
  color: #9ca3af !important;
}

.widget-actions {
  display: flex;
  gap: 2px;
}

.btn-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-action:hover {
  background: rgba(0, 0, 0, 0.06);
}

.btn-action .app-icon {
  font-size: 16px;
  color: #6b7280;
}

.btn-remove:hover {
  background: #fee2e2;
}

.btn-remove:hover .app-icon {
  color: #ef4444;
}

.widget-body {
  padding: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/User2/common/WidgetCard.vue